'use strict';

/**
 * View for a single species in edit/create dialog
 *
 * @category   View
 * @module     collectio.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../../templates/components/detail/field-species.hbs');

var SpeciesComponent = ItemView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },
    },

    hasValue: function() {
        var field = this.getOption('field');

        return this.model.get(field.name).length ? true : false;
    },
});

module.exports = SpeciesComponent;